
<main class="custom-route__container">
  @if (isLoading()) {
    <app-bus-loader [title]="('Estamos modificando tu ruta personalizada' | translate) + '...'" /> 
  } @else {
    @if (customRouteData()) {
      @if (isMobile()) {
        <app-custom-route-mobile />
      } @else {
        <app-custom-route-desktop />
      }
    }
  }
</main>


